import { gql } from '@apollo/client';
const REMOVE_MODEL_PICTURE = gql `
  mutation RemoveModelPicture($modelSpecificationId: ID!) {
    removeModelSpecificationPicture(modelSpecificationId: $modelSpecificationId) {
      removed
    }
  }
`;
export default REMOVE_MODEL_PICTURE;
